import { render } from "./MealAllowance.vue?vue&type=template&id=0a888ace&scoped=true"
import script from "./MealAllowance.vue?vue&type=script&lang=js"
export * from "./MealAllowance.vue?vue&type=script&lang=js"

import "./MealAllowance.vue?vue&type=style&index=0&id=0a888ace&scoped=true&lang=less"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a888ace"]])

export default __exports__